export default [
    {
        header: 'Component(Sidebar):internal-tools',
        action: 'see',
        resource: 'internal-tools-section',
    },
    {
        title: 'Component(Sidebar):internal-tools-product',
        icon: 'ToolIcon',
        route: null,
        children: [
            {
                title: 'Component(Sidebar):internal-tools-product-supplier-reply-review',
                route: 'internal-tools-product-supplier-reply-review',
                action: 'visit',
                resource: 'internal-tools-product-supplier-reply-review',
            },
        ],
    },
]
